import { FLOW_STEP_EVENT, FLOW_STEP_REVIEW, FLOW_STEP_VEHICLE } from 'subscription-flow/constants'

import ReviewPay from 'booking/components/flow-steps/ReviewPay'
import DateProductSelection from './DateProductSelection/DateProductSelection'
import VehicleSelection from './VehicleSelection/VehicleSelection'
import GuestCheckoutVehicleSelection from 'booking/components/GuestCheckoutComponents/GuestCheckoutVehicleSelection'
import { ANALYTICS_FLOW_TYPE_EVENT } from 'analytics/constants'

const EventFlow = ({
    grsId,
    activeStep,
    bookingData,
    onNext,
    setDateRange,
    setEvent,
    setVehicle,
    rateVehicle,
    errorMessage,
    currentItemIndex,
    showPixPaymentMethod,
    guestCheckoutEnabled,
}) => (
    <div>
        {activeStep === FLOW_STEP_EVENT && (
            <DateProductSelection
                grsId={grsId}
                onNext={onNext}
                setDateRange={setDateRange}
                setProduct={setEvent}
                bookingData={bookingData}
                currentItemIndex={currentItemIndex}
            />
        )}
        {activeStep === FLOW_STEP_VEHICLE &&
            (guestCheckoutEnabled ? (
                <GuestCheckoutVehicleSelection
                    onNext={onNext}
                    setVehicle={setVehicle}
                    analyticsFlowType={ANALYTICS_FLOW_TYPE_EVENT}
                />
            ) : (
                <VehicleSelection
                    onNext={onNext}
                    setVehicle={setVehicle}
                    bookingData={bookingData}
                    rate={rateVehicle}
                    analyticsFlowType={ANALYTICS_FLOW_TYPE_EVENT}
                />
            ))}
        {activeStep === FLOW_STEP_REVIEW && !errorMessage && (
            <ReviewPay
                grsId={grsId}
                bookingData={bookingData}
                rate={bookingData?.event}
                isEventFlow
                showPixPaymentMethod={showPixPaymentMethod}
                analyticsFlowType={ANALYTICS_FLOW_TYPE_EVENT}
            />
        )}
    </div>
)

export { EventFlow }
